import { Section, adjustContentVisibility } from '@/components/shared/Content';
import type React from 'react';
import styled from 'styled-components';
import { DesktopItemsGallery } from './DesktopItemsGallery';
import { MobileItemsGallery } from './MobileItemsGallery';
import { type GalleryProps, MainTitle, Subtitle } from './Shared';

const StyledSection = styled(Section)`
  ${adjustContentVisibility}
`;

const SCROLL_ANCHOR = 'supercharge';

export interface SuperChargeProps extends Pick<GalleryProps, 'items'> {
  title?: string;
  subtitle?: string;
}
export const SuperCharge: React.FC<SuperChargeProps> = ({ items, title, subtitle }) => {
  return (
    <StyledSection pt={[40, 70]} pb={[40, 70]} px={20} id={SCROLL_ANCHOR}>
      <MainTitle>{title}</MainTitle>
      <Subtitle>{subtitle}</Subtitle>
      <MobileItemsGallery items={items} />
      <DesktopItemsGallery items={items} />
    </StyledSection>
  );
};
